import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductOptions.css';
import { STATIC_IMAGES } from '../../data/staticData';
import { useCatalog } from '../../Components/CatalogContext';

function ProductOptions({ currentCategory }) {
    const { categories: catalogCategories } = useCatalog();
    const navigate = useNavigate();
    const [hoveredCard, setHoveredCard] = useState(null);
    const [scrollY, setScrollY] = useState(0);

    const getCategoryImage = (categoryName) => {
        const imageMap = {
            'cakes': STATIC_IMAGES.product,
            'cookies': STATIC_IMAGES.product2,
            'cheesecakes': STATIC_IMAGES.product3,
            'brownies': STATIC_IMAGES.product2,
            'pastries': STATIC_IMAGES.product,
            'entremets': STATIC_IMAGES.product3
        };
        return imageMap[categoryName] || STATIC_IMAGES.product;
    };

    const getCategoryColor = (categoryName) => {
        const colorMap = {
            'cakes': '#896547',
            'cookies': '#A67B5B',
            'pastries': '#BE8C63',
            'brownies': '#8B4513',
            'cheesecakes': '#A67B5B',
            'entremets': '#8B4513'
        };
        return colorMap[categoryName] || '#896547';
    };

    const categories = useMemo(() => catalogCategories.map(category => ({
        id: category.Name.toLowerCase(),
        title: category.Name.toUpperCase(),
        description: category.Description,
        image: getCategoryImage(category.Name.toLowerCase()),
        color: getCategoryColor(category.Name.toLowerCase()),
        route: `/category/${category.Name.toLowerCase()}`
    })), [catalogCategories]);

    // Filter out the current category and show only 2 other categories
    // Normalize the current category to lowercase for comparison
    const normalizedCurrentCategory = currentCategory ? currentCategory.toLowerCase() : '';
    const otherCategories = categories.filter(cat => cat.id !== normalizedCurrentCategory);
    const displayCategories = otherCategories.slice(0, 2); // Show only first 2

    // Debug logging
    console.log('ProductOptions Debug:', {
        currentCategory,
        normalizedCurrentCategory,
        allCategories: categories.map(c => c.id),
        otherCategories: otherCategories.map(c => c.id),
        displayCategories: displayCategories.map(c => c.id)
    });

    const handleCardClick = (route) => {
        navigate(route);
    };

    // Scroll effect for title
    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const titleText = "ROOM FOR MORE?";

    if (displayCategories.length === 0) return null;

    return (
        <div className="product-options-section">
            <div className="options-header">
                <h2 
                    className="options-title"
                    style={{
                        transform: `translateY(${scrollY * 0.02}px)`,
                        transition: 'transform 0.1s ease-out'
                    }}
                >
                    {titleText.split('').map((letter, index) => (
                        <span key={index}>
                            {letter === ' ' ? '\u00A0' : letter}
                        </span>
                    ))}
                </h2>
            </div>

            <div className="options-grid">
                {displayCategories.map((category, index) => (
                    <div
                        key={category.id}
                        className="option-card"
                        style={{ 
                            backgroundColor: category.color
                        }}
                        onClick={() => handleCardClick(category.route)}
                        onMouseEnter={() => setHoveredCard(category.id)}
                        onMouseLeave={() => setHoveredCard(null)}
                    >
                        <div className="card-image-container1">
                            <img
                                src={category.image}
                                alt={category.title}
                                className="card-image1"
                                onError={(e) => { e.target.src = STATIC_IMAGES.product; }}
                            />
                        </div>
                        <h3 className="cardtitle">
                            {category.title}
                        </h3>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ProductOptions; 